import { map } from 'rxjs/operators';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@app/app.config';
import { ContextTargetData, CurrentContextViewModel } from '@circlon/operate-api-model';

@Injectable({
  providedIn: 'root',
})
export class ContextDataService {
  private baseUrl = `${this.appConfig.apiBaseEndpoint}v1.0/context`;

  constructor(private httpClient: HttpClient, @Inject(APP_CONFIG) private appConfig: AppConfig) {}

  getImpersonationTargets$(): Observable<ContextTargetData[]> {
    const url = `${this.baseUrl}/target`;
    return this.httpClient.get<{ data: ContextTargetData[] }>(url).pipe(
      map(obj => {
        return obj.data;
      })
    );
  }

  getCurrentContext(): Promise<CurrentContextViewModel> {
    const url = `${this.baseUrl}`;
    return lastValueFrom(this.httpClient.get<CurrentContextViewModel>(url)).then(res => CurrentContextViewModel.fromJS(res));
  }
}
